<!-- 二级导航 -->
<template>
  <div class="nav">
    <div class="nav-title">
      <img class="nav-logo" :src="src" />
      <span>{{ name }}</span>
    </div>
    <div
      v-for="(item, index) in menuItems"
      :key="index + item.value"
      :class="activeMenu === item.link ? 'menu active' : 'menu'"
      @click="changeMenu(item)"
    >
      <span>{{ item.name }}</span>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  props: [],

  components: {},

  data() {
    return {
      menuItems: [
        {
          name: '机构管理',
          link: '/admin/operate/department-manage',
          value: 'AdminDepartmentManage'
        },
        {
          name: '用户管理',
          link: '/admin/operate/operation-management',
          value: 'AdminOperationManage'
        },
        {
          name: '学校管理',
          link: '/admin/operate/school-manage',
          value: 'AdminSchoolManage'
        },
        {
          name: '学年管理',
          link: '/admin/operate/year-manage',
          value: 'AdminYearManage'
        },
        {
          name: '基础配置',
          link: '/admin/config/basic-config',
          value: 'AdminBasicConfigModule'
        },
        {
          name: '人员列表',
          link: '/district-admin/people/people-manage',
          value: 'PeopleManage'
        },
        {
          name: '处室管理',
          link: '/district-admin/people/department-manage',
          value: 'DistrictDepartmentManage'
        },
        {
          name: '权限管理',
          link: '/district-admin/permission/permission-manage',
          value: 'DistrictPermissionManage'
        },
        {
          name: '教师管理',
          link: '/school-admin/affair/teacher-manage',
          value: 'TeacherManage'
        },
        {
          name: '学生管理',
          link: '/school-admin/affair/student-manage',
          value: 'StudentManage'
        },
        {
          name: '班级管理',
          link: '/school-admin/affair/class-manage',
          value: 'ClassManage'
        },
        {
          name: '电子章管理',
          link: '/school-admin/affair/seal-manage',
          value: 'SealManage'
        },
        {
          name: '户籍信息',
          link: '/school-admin/affair/outer-info-manage',
          value: 'OuterInfoManage'
        },

        {
          name: '权限管理',
          link: '/school-admin/permission/permission-manage',
          value: 'PermissionManage'
        },
        {
          name: '综合评价',
          link: 'year-manage',
          value: 'SchoolJudgeManage'
        },
        {
          name: '素质报告',
          link: 'department-manage',
          value: 'SchoolQualityReport'
        },
        {
          name: '综合评价',
          link: 'school-manage',
          value: 'TeacherGradeJudge'
        },
        {
          name: '综合评价',
          link: 'year-manage',
          value: 'TeacherClassJudge'
        },

        {
          name: '素质报告',
          link: 'year-manage',
          value: 'TeacherGradeQualityReport'
        },
        {
          name: '素质报告',
          link: 'department-manage',
          value: 'TeacherClassQualityReport'
        },
        {
          name: '学期报告',
          link: 'school-manage',
          value: 'StudentTermManage'
        },
        {
          name: '毕业报告',
          link: 'year-manage',
          value: 'StudentGraduateManage'
        }
      ],
      activeMenu: '',
      cloneMenu: [
        {
          name: '机构管理',
          link: '/admin/operate/department-manage',
          value: 'AdminDepartmentManage'
        },
        {
          name: '用户管理',
          link: '/admin/operate/operation-management',
          value: 'AdminOperationManage'
        },
        {
          name: '学校管理',
          link: '/admin/operate/school-manage',
          value: 'AdminSchoolManage'
        },
        {
          name: '学年管理',
          link: '/admin/operate/year-manage',
          value: 'AdminYearManage'
        },
        {
          name: '基础配置',
          link: '/admin/config/basic-config',
          value: 'AdminBasicConfigModule'
        },
        {
          name: '人员列表',
          link: '/district-admin/people/people-manage',
          value: 'PeopleManage'
        },
        {
          name: '处室管理',
          link: '/district-admin/people/department-manage',
          value: 'DistrictDepartmentManage'
        },
        {
          name: '权限管理',
          link: '/district-admin/permission/permission-manage',
          value: 'DistrictPermissionManage'
        },
        {
          name: '教师管理',
          link: '/school-admin/affair/teacher-manage',
          value: 'TeacherManage'
        },
        {
          name: '学生管理',
          link: '/school-admin/affair/student-manage',
          value: 'StudentManage'
        },
        {
          name: '班级管理',
          link: '/school-admin/affair/class-manage',
          value: 'ClassManage'
        },
        {
          name: '学科管理',
          link: '/school-admin/affair/subject-manage',
          value: 'SubjectManage'
        },
        {
          name: '电子章管理',
          link: '/school-admin/affair/seal-manage',
          value: 'SealManage'
        },
        {
          name: '户籍信息',
          link: '/school-admin/affair/outer-info-manage',
          value: 'OuterInfoManage'
        },

        {
          name: '权限管理',
          link: '/school-admin/permission/permission-manage',
          value: 'PermissionManage'
        },
        {
          name: '综合评价',
          link: 'year-manage',
          value: 'SchoolJudgeManage'
        },
        {
          name: '素质报告',
          link: 'department-manage',
          value: 'SchoolQualityReport'
        },
        {
          name: '综合评价',
          link: 'school-manage',
          value: 'TeacherGradeJudge'
        },
        {
          name: '综合评价',
          link: 'year-manage',
          value: 'TeacherClassJudge'
        },

        {
          name: '素质报告',
          link: 'year-manage',
          value: 'TeacherGradeQualityReport'
        },
        {
          name: '素质报告',
          link: 'department-manage',
          value: 'TeacherClassQualityReport'
        },
        {
          name: '学期报告',
          link: 'school-manage',
          value: 'StudentTermManage'
        },
        {
          name: '毕业报告',
          link: 'year-manage',
          value: 'StudentGraduateManage'
        }
      ]
    }
  },

  watch: {
    'firstMenu.id': {
      handler(newVal, oldVal) {
        this.initMenu(true)
      }
    }
  },

  computed: {
    menu() {
      return JSON.parse(localStorage.getItem('firstNav'))
    },
    firstMenu() {
      let menu = this.$store.getters['user/getFirstNav']()
      return menu
    },
    src() {
      if (this.menu) {
        return this.menu.src
      } else if (this.firstMenu) {
        return this.firstMenu.src
      }
    },
    name() {
      if (this.menu) {
        return this.menu.name
      } else if (this.firstMenu) {
        return this.firstMenu.name
      }
    }
  },

  mounted() {
    this.initMenu()
  },

  methods: {
    initMenu(bool) {
      let menus = null
      let userInfo = this.$store.state.user
      if (!userInfo) {
        menus = this.$store.getters['user/getMenu']()
      } else {
        menus = userInfo.menus
      }
      let localMenu =
        JSON.parse(localStorage.getItem('firstNav')) || this.firstMenu
      let levelTwo = _.filter(menus, { level: 2, type: 1 })
      let secondNav = _.filter(levelTwo, { parentId: localMenu.id })
      let menuItems = _.cloneDeep(this.cloneMenu)
      let temp = []
      for (let index = 0; index < secondNav.length; index++) {
        let element = secondNav[index]
        for (let innerIndex = 0; innerIndex < menuItems.length; innerIndex++) {
          let innerElement = menuItems[innerIndex]
          if (innerElement.value === element.name) {
            this.$set(innerElement, 'id', element.id)
            temp.push(innerElement)
          }
        }
      }
      this.menuItems = temp
      if (bool) {
        this.activeMenu = temp[0].link
        this.$router.push({ path: temp[0].link })
      } else {
        this.activeMenu = this.$route.path
        this.$router.push({ path: this.$route.path })
      }
    },

    changeMenu(menu) {
      this.activeMenu = menu.link
      this.$router.push({ path: menu.link })
    }
  }
}
</script>

<style lang="scss" scoped>
.nav {
  position: relative;
  float: left;
  width: 200px;
  height: 100%;
  background: #ffffff;
  box-shadow: inset 0px 1px 1px 0px rgba(0, 0, 0, 0.12),
    1px 0px 1px 0px rgba(0, 0, 0, 0.12);
}
.nav-title {
  display: flex;
  align-items: center;
  width: 100%;
  height: 60px;
}
.nav-title span {
  position: absolute;
  left: 68px;
  height: 22px;
  font-size: 16px;
  font-weight: 500;
  color: var(--theme-color);
  line-height: 22px;
}
.nav-logo {
  position: absolute;
  left: 25px;
  font-size: 20px;
  margin-left: 10px;
  filter: invert(51%) sepia(88%) saturate(6434%) hue-rotate(231deg)
    brightness(97%) contrast(88%);
}
.menu {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 55px;
  cursor: pointer;
}
.active {
  background: #edeefc;
}
.menu span {
  font-size: 16px;
  font-weight: 400;
}
.active span {
  color: var(--theme-color);
}
</style>



// WEBPACK FOOTER //
// src/components/common/SecondNavBar.vue